import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import GlobalStyle from '../../styles/global';
import VariablesStyle from '../../styles/variables';
import BrandStyle from '../../styles/brand';
import Header from './Header';
import CookieBanner from '../cookieBanner/CookieBanner';
import Footer from '../main/footer/Footer';
import colors from '../../styles/colors';

const Container = styled.div`
  align-items: center;
  justify-content: center;
`;

const BottomSpacer = styled.div`
  height: var(--bottom-spacer-height, 0);
  width: 100%;
  flex-shrink: 0;
`;

const Chrome = ({ children, footer, header, path, classname }) => {
  return (
    <ThemeProvider theme={colors}>
      <Container className={classname} id="chromeContainer">
        <VariablesStyle />
        <BrandStyle />
        <GlobalStyle />
        {header && <Header path={path} />}
        {children}
        <CookieBanner />
        {footer && <Footer />}
        <BottomSpacer aria-hidden="true" />
      </Container>
    </ThemeProvider>
  );
};

Chrome.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.bool,
  header: PropTypes.bool,
  path: PropTypes.string.isRequired,
  classname: PropTypes.string,
};

Chrome.defaultProps = {
  footer: true,
  header: true,
};

export default Chrome;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/chrome/Chrome.js